import { render, staticRenderFns } from "./CommunityInvites.vue?vue&type=template&id=e3b13bce"
import script from "./CommunityInvites.vue?vue&type=script&lang=js"
export * from "./CommunityInvites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports